import { STORAGE_KEYS } from './../../../../services/storage.service';
import { Component, inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Supplier } from 'src/app/models/supplier.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ModalSupplierItemComponent } from 'src/app/components/inventory-modals/modal-supplier-item.component';
import { ModalProviderComponent } from 'src/app/components/inventory-modals/modal-provider.component';

@Component({
  selector: 'app-edit-provider',
  template: `
    <div class="d-flex mb-4 mt-4" *ngIf="supplier != null">
      <h2>Inventario</h2>
    </div>
    <div class="d-flex mb-4 mt-4" *ngIf="supplier != null">
      <div>
      <ul #subnav app-nav-inventory [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-2">
        
        <div class="list-group">
          <div class="list-group-item">
            <h2>Proveedor: {{supplier.name}}</h2>
          </div>
          <div class="list-group-item">
            <div class="d-flex">
              <div class="me-3"><img src="{{ supplier.avatar }}"></div>
              <div class="flex-fill">
                <div class="list-group">
                  <div class="list-group-item">
                    <div class="d-flex">
                      <div class="flex-fill">
                        <p>Nombre</p>
                      </div>
                      <div class="text-end">
                        {{supplier.name}}
                        <button class="btn btn-link btn-sm ms-2" (click)="openEditSupplierModal()">
                          <fa-icon [icon]="icons.faEdit"></fa-icon> Editar
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="list-group-item">
                    <div class="d-flex">
                      <div class="flex-fill">
                        <p>Descripción</p>
                      </div>
                      <div class="text-end">
                        <p class="mb-0">{{supplier.service}}</p>
                        <p class="mb-0">{{supplier.phone}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="list-group-item">
                    <div class="d-flex">
                      <div class="flex-fill">
                        <p>Sitio web</p>
                      </div>
                      <div class="text-end">{{supplier?.active}}</div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>      
      </div>
      <div class="ms-3 flex-fill">
        <div class="list-group">
          <div class="list-group-item">
            <div class="d-flex">
              <div class="flex-fill">Cliente</div>
              <!-- div class="">{{supplier.is_customer}}</div -->
            </div>
          </div>
          <div class="list-group-item">
            <div class="d-flex">
              <div class="flex-fill">Manufactura</div>
              <!-- div class="">{{supplier.is_manufacturer}}</div -->
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div class="d-flex"  *ngIf="supplier != null">
      <div class="flex-fill">
        <div class="list-group">
          <div class="list-group-item">
            <div class="d-flex">
              <div class="flex-fill">
                <h3>Artículos del proveedor</h3>
                <p class="text-muted">Artículos que provee este proveedor</p>
              </div>
              <div class="text-end">
                <button class="btn btn-zazz-default rounded-4 shadow-sm px-4 ms-2" (click)="openModalItems()">
                  <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
                  Agregar
                </button>
              </div>
            </div>
          </div>
          <div class="list-group-item">
            <table class="table table-sm" style="overflow-x: scroll;">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" class="text-start bg-zazz text-light py-2"># Artículo</th>
                  <th scope="col" class="text-start bg-zazz text-light py-2">Descripción</th>
                  <th scope="col" class="text-center bg-zazz text-light py-2">SKU</th>
                  <th scope="col" class="text-center bg-zazz text-light py-2">Cantidad</th>
                  <th scope="col" class="text-center bg-zazz text-light py-2">Precio unitario</th>
                  <th scope="col" class="text-center bg-zazz text-light py-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr app-tr-supplier-item
                  [supplierItem]="item"
                  [supplier]="supplier"
                  [profile]="profile"
                  [permissions]="permissions"
                  (itemDeleted)="loadSupplier(supplier!.id!)"
                  (editRequested)="onEditItem(item)"
                  *ngFor="let item of supplier.supplier_items"
                ></tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
    <app-modal-supplier-item
      [supplier]="supplier"
      (updateDismiss)="loadSupplier(supplier!.id!)"
    ></app-modal-supplier-item>
    <app-modal-provider
      [supplier]="supplier"
      (updateDismiss)="onSupplierUpdated($event)"
    ></app-modal-provider>
  `,
  styleUrls: []
})
export class EditProviderComponent {
  supplier: Supplier | null = null;
  profile: any = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PROFILE) ?? '{}');
  permissions: any = {};
  meta: any = {};

  @ViewChild(ModalSupplierItemComponent) modalSupplierItem !: ModalSupplierItemComponent;
  @ViewChild(ModalProviderComponent) modalProvider!: ModalProviderComponent;

  currentView: string = 'providers';

  constructor(
    private invService: InventoryService,
    private activeRoute: ActivatedRoute,
    public icons: IconsService
  ) { 
    this.activeRoute.params.subscribe(params => {
      this.loadSupplier(params['id']);
    });
  }

  loadSupplier(id: number) {
    console.log("loading supplier with id => ", id);
    this.invService.getSupplierById(id).subscribe({
      next: (supplier: Supplier) => {
        console.log("supplier => ", supplier);
        this.supplier = supplier;
      },
      error: (err: any) => {
        console.error("Error loading supplier: ", err);
      }
    });
  }

  openModalItems() {
    const modalTemplate: any | undefined = this.modalSupplierItem;
    if (modalTemplate) {
      this.modalSupplierItem.openModal(modalTemplate['modalSupplierItem']);
    }
  }

  onEditItem(item: any) {
    const modalTemplate: any | undefined = this.modalSupplierItem;
    if (modalTemplate) {
      this.modalSupplierItem.openModal(modalTemplate['modalSupplierItem'], item);
    }
  }

  openEditSupplierModal() {
    const modalTemplate: any | undefined = this.modalProvider;
    if (modalTemplate) {
      this.modalProvider.openModal(modalTemplate['modalProvider'], this.supplier!);
    }
  }

  onSupplierUpdated(event: any) {
    // Reload supplier info after update
    if (this.supplier) {
      this.loadSupplier(this.supplier.id!);
    }
  }
}
